module.exports = __webpack_public_path__ + "static/media/camper_huren_sevilla.8ed1b325.jpeg";